import React from "react";
import { useQueryParams } from "../hoc/with-query-params";
import { QUERY_PARAMS } from "rtr-constants";
import VisualNav from "./visual-nav";

interface VisualNavWrapperProps {
  isSearchResultGrid: boolean;
  showNavPillFlag: boolean;
}

const VisualNavWrapper: React.FC<VisualNavWrapperProps> = ({ isSearchResultGrid, showNavPillFlag }) => {
  // these actions are only appended to the url if the user navigates to the grid from the shortlists page or the shortlists dropdown. Dependent on the structure of lib/views/shortlist/index.erb.
  const action = useQueryParams(QUERY_PARAMS.ACTION);

  const shouldHide =
    action?.queryParams?.action === "click_heartSubmenu" ||
    action?.queryParams?.action === "click_overlay" ||
    isSearchResultGrid;

  if (shouldHide) {
    return null;
  }

  return <VisualNav showNavPillFlag={showNavPillFlag} />;
};

export default VisualNavWrapper;
